import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid,Box,Tab } from '@mui/material';
import {TabContext,TabList,TabPanel} from '@mui/lab';
import { getDriver } from 'redux/actions/UserDriver';
import { getSubVendor } from 'redux/actions/UserSubVendor';
import { updateAssignSubVendor } from 'redux/actions/UserAllot';
import CommonTable from 'components/commonTable/CommonTable';
import AllotDialog from 'components/allotDialog/AllotDialog';
import ConfirmModal from 'components/confirmModal/ConfirmModal';
import Loader from 'components/loader/Loader';
import useModal from 'hooks/useModal';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function AssignDriverView() {
  const [value, setValue] = useState('requested');
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data)
  const loader = useSelector((state) => state?.userDriver?.loading)
  const subVendors = useSelector(state => state?.userSubVendor?.userSubVendor?.data)
  const [filterSubVendor, setFilterSubVendor] = useState(subVendors?.body)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [driverId, setDriverId] = useState('')
  const vendorId = localStorage.getItem('ID')
  const { open, toggle } = useModal();

  const id = localStorage.getItem('companyId')

  let filterData = {
    assignId: id,
    status: "Active",
    page: "",
    pageSize: "",
    allot: value,
    vendorId: id
  }
  let filterDataDriver = {
    assignId: vendorId,
    status: "",
    page: page,
    pageSize: rowsPerPage,
    allot: value,
    vendorId: vendorId
  }

  useEffect(() => {
    filterAllSubvendors()
  }, [searchQuery])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    filterDataDriver = { ...filterDataDriver, page: newPage }
    dispatch(getDriver(filterDataDriver))
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    filterDataDriver = { ...filterDataDriver, page: 0, pageSize: parseInt(event.target.value) }
    dispatch(getDriver(filterDataDriver))
  };

  useEffect(() => {
    setFilterSubVendor(subVendors?.body)
  }, [subVendors])

  useEffect(() => {
    dispatch(getDriver(filterDataDriver));
    dispatch(getSubVendor(filterData))
  }, [])

  const onClickTableVendor = (data) => {
    setDriverId(data?.id)
    setOpenDialog(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
    filterDataDriver = { ...filterDataDriver, allot: newValue, page:0 }
    dispatch(getDriver(filterDataDriver));
  };

  const handelSearch = (val) => {
    setSearchQuery(val)
  }

  const filterAllSubvendors = () => {
    let filterSubVendorList = [];

    if (searchQuery !== "") {
      filterSubVendorList = subVendors?.body.filter(driver => driver.companyName.toLowerCase().includes(searchQuery?.toLowerCase()))
    } else {
      filterSubVendorList = subVendors?.body
    }

    setFilterSubVendor(filterSubVendorList)
  }

  const handleClose = () => {
    setOpenDialog(false);
    setSearchQuery('')
  }

  const submittAssign = (data) => {
    const val = {
      driverId: driverId,
      companyId: data?.companyId,
      allot: value,
      assignId: id,
      subVendorData: filterData
    }
    dispatch(updateAssignSubVendor(val,toggle));
    handleClose();
  }

  const onClickMoreIcon = (data, type) => {
    if(type?.toLowerCase() == 'reassign'){
      setDriverId(data?.id)
      setOpenDialog(true);
    }else{
      const val = {
        driverId: data?.id,
        companyId: '',
        allot: value,
        assignId: '',
        subVendorData: filterData,
        unAssined:'unAssined'
      }
      dispatch(updateAssignSubVendor(val,toggle));
    }
  };

    //roles and permission
    const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
    const allotDriverAccess = roleAndPermissionEnum.operation
    const accessForAssign = handlePermissions(roleAndPermissions, allotDriverAccess.moduleKey, {customAccess: allotDriverAccess.allotDriver.allotDriverAssign});
    

  return (
    <div>
      {loader ?
        <Loader />
        :
        <Grid container>
          <Grid item className="tabContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                     className='minHeight32'
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                      }}
                    >
                      <Tab label="Request" value="requested" className="tabStyle" />
                      <Tab label="Assigned" value="assigned" className="tabStyle" />
                    </TabList>
                  </Grid>
                </Grid>
                <TabPanel
                  value="requested"
                  sx={{ width: '100%' }}
                  className="vendotTable"
                >
                  <CommonTable
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    handleChangePage={handleChangePage}
                    data={driverData}
                    onClickTableVendor={onClickTableVendor}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                    accessForAssign={accessForAssign}
                    />
                </TabPanel>
                <TabPanel value="assigned" className="vendotTable">
                  <CommonTable
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    handleChangePage={handleChangePage}
                    data={driverData}
                    page={page}
                    isClickable = {false}
                    rowsPerPage={rowsPerPage}
                    onClickMoreIcon={onClickMoreIcon}
                    tabName={'unAssignTab'}
                    viewMoreIcon={!accessForAssign}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>}
      {openDialog && (
        <AllotDialog
          type="subvendorView"
          onSearch={handelSearch}
          openDialog={openDialog}
          allotData={filterSubVendor}
          title={'Available'}
          titleType={'Sub-Vendor'}
          placeholder={'Search sub-vendor'}
          handleClose={handleClose}
          submittAssign={submittAssign}
        />
      )}
      <ConfirmModal open={open} toggle={toggle} pageName='assignDriver' />
    </div>
  );
}

export default AssignDriverView;
